import React, {Component} from 'react';
import {connect} from '~/redux/connect';
import {modelActionsCreator} from "~/actions/model_actions";
import {getResultPerPage, getResultsPage, getResultsValue, getTooltipsActive} from "~/stateGetter";
import PaginationBar from '~/components/DataTable/PaginationBar';
import { settingsActionCreator } from '~/actions/settingsActions';

const RXModelResultPagination = connect(
    (state, {modelId}) => {
        let resultValue = getResultsValue(state, modelId);

        return {
            perPage: getResultPerPage(state, modelId),
            currentPage: resultValue.page,
            total: resultValue.total,
            tooltipsActive: getTooltipsActive(state)
        };
    },
    (dispatch, {modelId}) => {
        let modelActions = modelActionsCreator(modelId),
            settingActions = settingsActionCreator(modelId);

        return {
            onChangePerPage: (perPage) => dispatch(settingActions.changePerPage(perPage)),
            onChangePage: (page) => dispatch(modelActions.changePage(page)),
        }
    }
)(PaginationBar);

export default RXModelResultPagination;